import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=0b5b48aa&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=0b5b48aa&prod&lang=scss&scoped=true"
import style1 from "./ImageViewer.vue?vue&type=style&index=1&id=0b5b48aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b48aa",
  null
  
)

export default component.exports